var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRoles = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 12.3334H14.6668V11.0001C14.6668 9.89551 13.7714 9.00008 12.6668 9.00008C12.0298 9.00008 11.4623 9.29795 11.096 9.76201M11.3335 12.3334H4.66683M11.3335 12.3334V11.0001C11.3335 10.5626 11.2492 10.1448 11.096 9.76201M4.66683 12.3334H1.3335V11.0001C1.3335 9.89551 2.22893 9.00008 3.3335 9.00008C3.97057 9.00008 4.53807 9.29795 4.90433 9.76201M4.66683 12.3334V11.0001C4.66683 10.5626 4.75111 10.1448 4.90433 9.76201M4.90433 9.76201C5.39583 8.5341 6.59671 7.66675 8.00016 7.66675C9.40362 7.66675 10.6045 8.5341 11.096 9.76201M10.0002 3.66675C10.0002 4.77132 9.10473 5.66675 8.00016 5.66675C6.89559 5.66675 6.00016 4.77132 6.00016 3.66675C6.00016 2.56218 6.89559 1.66675 8.00016 1.66675C9.10473 1.66675 10.0002 2.56218 10.0002 3.66675ZM14.0002 5.66675C14.0002 6.40313 13.4032 7.00008 12.6668 7.00008C11.9305 7.00008 11.3335 6.40313 11.3335 5.66675C11.3335 4.93037 11.9305 4.33341 12.6668 4.33341C13.4032 4.33341 14.0002 4.93037 14.0002 5.66675ZM4.66683 5.66675C4.66683 6.40313 4.06988 7.00008 3.3335 7.00008C2.59712 7.00008 2.00016 6.40313 2.00016 5.66675C2.00016 4.93037 2.59712 4.33341 3.3335 4.33341C4.06988 4.33341 4.66683 4.93037 4.66683 5.66675Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoles, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/roles.8f8af060.svg";
export { ForwardRef as ReactComponent };